import * as React from 'react';

import TwoColumn from 'components/TwoColumn';
import useLiveData from 'hooks/useLiveData';
import { useStaticQuery, graphql } from 'gatsby';

const TwoColumnProvider = (props) => {
	const data = useStaticQuery(graphql`
		query twoColumnsVersion2 {
		  allSmartTagsTwoColumn {
		    edges {
		      node {
		        id
		        orientation
				flipOrientation
		        flush
				background
				backgroundImage
				backgroundProps
				padding
		        contentBlocks {
					body
					breakpoints
		        }
		      }
		    }
		  }
		}
	`);
	const {response} = useLiveData({
		namespace: 'SmartTags',
		model: 'TwoColumn',
		method: 'all',
		staticData: data,
		graphqlKey: 'allSmartTagsTwoColumn',
	});
	if (response.data.length === 0)return null;
	let attr;
	for (let item of response.data) {
		if (item.id === props.id)attr = item;
	}
	if (!attr)return null;
	return <TwoColumn {...attr} />
}

export default TwoColumnProvider;